import { render, staticRenderFns } from "./PassengerInformationTemplates.vue?vue&type=template&id=01e60409&scoped=true"
import script from "./PassengerInformationTemplates.vue?vue&type=script&lang=js"
export * from "./PassengerInformationTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e60409",
  null
  
)

export default component.exports